//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
const defaultTheme = {};
export const ThemeContext = /*#__PURE__*/React.createContext(defaultTheme);